/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  BodyUploadDocument,
  DocumentOut,
  DocumentSharingIn,
  DownloadUrlOut,
  HTTPValidationError,
  ListDocumentsParams,
  PaginatedDocumentOut,
  RecentDocumentsOut
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listDocumentsResponse200 = {
  data: PaginatedDocumentOut
  status: 200
}

export type listDocumentsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listDocumentsResponseSuccess = (listDocumentsResponse200) & {
  headers: Headers;
};
export type listDocumentsResponseError = (listDocumentsResponse422) & {
  headers: Headers;
};

export type listDocumentsResponse = (listDocumentsResponseSuccess | listDocumentsResponseError)

export const getListDocumentsUrl = (params: ListDocumentsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/documents?${stringifiedParams}` : `/api/documents`
}

/**
 * @summary List Documents
 */
export const listDocuments = async (params: ListDocumentsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listDocumentsResponse> => {

  return apiFetch<listDocumentsResponse>(getListDocumentsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListDocumentsQueryKey = (params?: ListDocumentsParams,) => {
    return [
    `/api/documents`, ...(params ? [params] : [])
    ] as const;
    }


export const getListDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listDocuments>>, TError = HTTPValidationError>(params: ListDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocuments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListDocumentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listDocuments>>> = ({ signal }) => listDocuments(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listDocuments>>>
export type ListDocumentsQueryError = HTTPValidationError


export function useListDocuments<TData = Awaited<ReturnType<typeof listDocuments>>, TError = HTTPValidationError>(
 params: ListDocumentsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocuments>>,
          TError,
          Awaited<ReturnType<typeof listDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDocuments<TData = Awaited<ReturnType<typeof listDocuments>>, TError = HTTPValidationError>(
 params: ListDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listDocuments>>,
          TError,
          Awaited<ReturnType<typeof listDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListDocuments<TData = Awaited<ReturnType<typeof listDocuments>>, TError = HTTPValidationError>(
 params: ListDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocuments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Documents
 */

export function useListDocuments<TData = Awaited<ReturnType<typeof listDocuments>>, TError = HTTPValidationError>(
 params: ListDocumentsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listDocuments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListDocumentsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type uploadDocumentResponse201 = {
  data: DocumentOut
  status: 201
}

export type uploadDocumentResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type uploadDocumentResponseSuccess = (uploadDocumentResponse201) & {
  headers: Headers;
};
export type uploadDocumentResponseError = (uploadDocumentResponse422) & {
  headers: Headers;
};

export type uploadDocumentResponse = (uploadDocumentResponseSuccess | uploadDocumentResponseError)

export const getUploadDocumentUrl = () => {




  return `/api/documents`
}

/**
 * @summary Upload Document
 */
export const uploadDocument = async (bodyUploadDocument: BodyUploadDocument, options?: Parameters<typeof apiFetch>[1]): Promise<uploadDocumentResponse> => {
    const formData = new FormData();
formData.append(`entity_type`, bodyUploadDocument.entity_type);
formData.append(`entity_id`, bodyUploadDocument.entity_id.toString())
formData.append(`file`, bodyUploadDocument.file);

  return apiFetch<uploadDocumentResponse>(getUploadDocumentUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getUploadDocumentMutationKey = () => ['uploadDocument'] as const;

export const getUploadDocumentMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadDocument>>, TError,UploadDocumentMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadDocument>>, TError,UploadDocumentMutationVariables, TContext> => {

const mutationKey = getUploadDocumentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadDocument>>, UploadDocumentMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  uploadDocument(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UploadDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof uploadDocument>>>
    export type UploadDocumentMutationBody = BodyUploadDocument
    export type UploadDocumentMutationError = HTTPValidationError
    export type UploadDocumentMutationVariables = {data: BodyUploadDocument}

    /**
 * @summary Upload Document
 */
export const useUploadDocument = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadDocument>>, TError,UploadDocumentMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadDocument>>,
        TError,
        UploadDocumentMutationVariables,
        TContext
      > => {
      return useMutation(getUploadDocumentMutationOptions(options), queryClient);
    }
    export type listRecentDocumentsResponse200 = {
  data: RecentDocumentsOut
  status: 200
}

export type listRecentDocumentsResponseSuccess = (listRecentDocumentsResponse200) & {
  headers: Headers;
};
;

export type listRecentDocumentsResponse = (listRecentDocumentsResponseSuccess)

export const getListRecentDocumentsUrl = () => {




  return `/api/documents/recent`
}

/**
 * @summary List Recent Documents
 */
export const listRecentDocuments = async ( options?: Parameters<typeof apiFetch>[1]): Promise<listRecentDocumentsResponse> => {

  return apiFetch<listRecentDocumentsResponse>(getListRecentDocumentsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListRecentDocumentsQueryKey = () => {
    return [
    `/api/documents/recent`
    ] as const;
    }


export const getListRecentDocumentsQueryOptions = <TData = Awaited<ReturnType<typeof listRecentDocuments>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecentDocuments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListRecentDocumentsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listRecentDocuments>>> = ({ signal }) => listRecentDocuments({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listRecentDocuments>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListRecentDocumentsQueryResult = NonNullable<Awaited<ReturnType<typeof listRecentDocuments>>>
export type ListRecentDocumentsQueryError = unknown


export function useListRecentDocuments<TData = Awaited<ReturnType<typeof listRecentDocuments>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecentDocuments>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRecentDocuments>>,
          TError,
          Awaited<ReturnType<typeof listRecentDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRecentDocuments<TData = Awaited<ReturnType<typeof listRecentDocuments>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecentDocuments>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listRecentDocuments>>,
          TError,
          Awaited<ReturnType<typeof listRecentDocuments>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListRecentDocuments<TData = Awaited<ReturnType<typeof listRecentDocuments>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecentDocuments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Recent Documents
 */

export function useListRecentDocuments<TData = Awaited<ReturnType<typeof listRecentDocuments>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listRecentDocuments>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListRecentDocumentsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type getDocumentDownloadUrlResponse200 = {
  data: DownloadUrlOut
  status: 200
}

export type getDocumentDownloadUrlResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type getDocumentDownloadUrlResponseSuccess = (getDocumentDownloadUrlResponse200) & {
  headers: Headers;
};
export type getDocumentDownloadUrlResponseError = (getDocumentDownloadUrlResponse422) & {
  headers: Headers;
};

export type getDocumentDownloadUrlResponse = (getDocumentDownloadUrlResponseSuccess | getDocumentDownloadUrlResponseError)

export const getGetDocumentDownloadUrlUrl = (documentId: number,) => {




  return `/api/documents/${documentId}/download-url`
}

/**
 * @summary Get Document Download Url
 */
export const getDocumentDownloadUrl = async (documentId: number, options?: Parameters<typeof apiFetch>[1]): Promise<getDocumentDownloadUrlResponse> => {

  return apiFetch<getDocumentDownloadUrlResponse>(getGetDocumentDownloadUrlUrl(documentId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetDocumentDownloadUrlQueryKey = (documentId: number,) => {
    return [
    `/api/documents/${documentId}/download-url`
    ] as const;
    }


export const getGetDocumentDownloadUrlQueryOptions = <TData = Awaited<ReturnType<typeof getDocumentDownloadUrl>>, TError = HTTPValidationError>(documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentDownloadUrl>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDocumentDownloadUrlQueryKey(documentId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDocumentDownloadUrl>>> = ({ signal }) => getDocumentDownloadUrl(documentId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: documentId !== null && documentId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDocumentDownloadUrl>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetDocumentDownloadUrlQueryResult = NonNullable<Awaited<ReturnType<typeof getDocumentDownloadUrl>>>
export type GetDocumentDownloadUrlQueryError = HTTPValidationError


export function useGetDocumentDownloadUrl<TData = Awaited<ReturnType<typeof getDocumentDownloadUrl>>, TError = HTTPValidationError>(
 documentId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentDownloadUrl>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentDownloadUrl>>,
          TError,
          Awaited<ReturnType<typeof getDocumentDownloadUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentDownloadUrl<TData = Awaited<ReturnType<typeof getDocumentDownloadUrl>>, TError = HTTPValidationError>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentDownloadUrl>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDocumentDownloadUrl>>,
          TError,
          Awaited<ReturnType<typeof getDocumentDownloadUrl>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetDocumentDownloadUrl<TData = Awaited<ReturnType<typeof getDocumentDownloadUrl>>, TError = HTTPValidationError>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentDownloadUrl>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Get Document Download Url
 */

export function useGetDocumentDownloadUrl<TData = Awaited<ReturnType<typeof getDocumentDownloadUrl>>, TError = HTTPValidationError>(
 documentId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDocumentDownloadUrl>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetDocumentDownloadUrlQueryOptions(documentId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type setDocumentSharingResponse200 = {
  data: DocumentOut
  status: 200
}

export type setDocumentSharingResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type setDocumentSharingResponseSuccess = (setDocumentSharingResponse200) & {
  headers: Headers;
};
export type setDocumentSharingResponseError = (setDocumentSharingResponse422) & {
  headers: Headers;
};

export type setDocumentSharingResponse = (setDocumentSharingResponseSuccess | setDocumentSharingResponseError)

export const getSetDocumentSharingUrl = (documentId: number,) => {




  return `/api/documents/${documentId}/sharing`
}

/**
 * @summary Set Document Sharing
 */
export const setDocumentSharing = async (documentId: number,
    documentSharingIn: DocumentSharingIn, options?: Parameters<typeof apiFetch>[1]): Promise<setDocumentSharingResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<setDocumentSharingResponse>(getSetDocumentSharingUrl(documentId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(documentSharingIn)
  }
);}





export const getSetDocumentSharingMutationKey = () => ['setDocumentSharing'] as const;

export const getSetDocumentSharingMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDocumentSharing>>, TError,SetDocumentSharingMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setDocumentSharing>>, TError,SetDocumentSharingMutationVariables, TContext> => {

const mutationKey = getSetDocumentSharingMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setDocumentSharing>>, SetDocumentSharingMutationVariables> = (props) => {
          const {documentId,data} = props ?? {};

          return  setDocumentSharing(documentId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SetDocumentSharingMutationResult = NonNullable<Awaited<ReturnType<typeof setDocumentSharing>>>
    export type SetDocumentSharingMutationBody = DocumentSharingIn
    export type SetDocumentSharingMutationError = HTTPValidationError
    export type SetDocumentSharingMutationVariables = {documentId: number;data: DocumentSharingIn}

    /**
 * @summary Set Document Sharing
 */
export const useSetDocumentSharing = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setDocumentSharing>>, TError,SetDocumentSharingMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setDocumentSharing>>,
        TError,
        SetDocumentSharingMutationVariables,
        TContext
      > => {
      return useMutation(getSetDocumentSharingMutationOptions(options), queryClient);
    }
    export type deleteDocumentResponse204 = {
  data: void
  status: 204
}

export type deleteDocumentResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type deleteDocumentResponseSuccess = (deleteDocumentResponse204) & {
  headers: Headers;
};
export type deleteDocumentResponseError = (deleteDocumentResponse422) & {
  headers: Headers;
};

export type deleteDocumentResponse = (deleteDocumentResponseSuccess | deleteDocumentResponseError)

export const getDeleteDocumentUrl = (documentId: number,) => {




  return `/api/documents/${documentId}`
}

/**
 * @summary Delete Document
 */
export const deleteDocument = async (documentId: number, options?: Parameters<typeof apiFetch>[1]): Promise<deleteDocumentResponse> => {

  return apiFetch<deleteDocumentResponse>(getDeleteDocumentUrl(documentId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteDocumentMutationKey = () => ['deleteDocument'] as const;

export const getDeleteDocumentMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocument>>, TError,DeleteDocumentMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteDocument>>, TError,DeleteDocumentMutationVariables, TContext> => {

const mutationKey = getDeleteDocumentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteDocument>>, DeleteDocumentMutationVariables> = (props) => {
          const {documentId} = props ?? {};

          return  deleteDocument(documentId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteDocumentMutationResult = NonNullable<Awaited<ReturnType<typeof deleteDocument>>>

    export type DeleteDocumentMutationError = HTTPValidationError
    export type DeleteDocumentMutationVariables = {documentId: number}

    /**
 * @summary Delete Document
 */
export const useDeleteDocument = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteDocument>>, TError,DeleteDocumentMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteDocument>>,
        TError,
        DeleteDocumentMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteDocumentMutationOptions(options), queryClient);
    }
